import React, { useRef, useEffect } from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import SunIllustration from '../components/SunIllustration';

var TOTAL_DAYS = 30;
var CURRENT_DAY = 8;
var MILESTONES = [4, 10, 15, 21, 30];

export default function GoalsScreen() {
  var scrollRef = useRef(null);
  var days = Array.from({ length: TOTAL_DAYS }, function(_, i) { return i + 1; });

  useEffect(function() {
    if (scrollRef.current) {
      var target = Math.max(0, (CURRENT_DAY / TOTAL_DAYS) * (TOTAL_DAYS * 35) - 250);
      scrollRef.current.scrollTo({ y: target, animated: false });
    }
  }, []);

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.safe} edges={['top']}>
        <View style={styles.dateRow}>
          <Text style={styles.dateText}>Fri, Jan.24th</Text>
          <Icon name="mail-outline" size={20} color={Colors.textMid} />
        </View>
        <View style={styles.sunWrap}><SunIllustration size={65} /></View>

        <View style={styles.milestoneHeader}>
          <Icon name="menu" size={18} color="#fff" />
          <Text style={styles.milestoneTitle}>Milestone 1: Getting Started</Text>
        </View>

        <ScrollView ref={scrollRef} style={styles.scroll} contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
          {days.map(function(day, i) {
            var done = day < CURRENT_DAY;
            var isCur = day === CURRENT_DAY;
            var isMile = MILESTONES.indexOf(day) !== -1;
            var progress = i / (TOTAL_DAYS - 1);
            var xOffset = Math.sin(progress * Math.PI * 2.5) * 70;

            return (
              <View key={day} style={[styles.dayRow, { marginLeft: 90 + xOffset, marginBottom: isMile ? 14 : 8 }]}>
                <Text style={[
                  styles.dayLabel,
                  { left: -82 - xOffset },
                  isCur && styles.dayLabelCurrent,
                  done && styles.dayLabelDone,
                  !done && !isCur && styles.dayLabelFuture,
                ]}>
                  {(isCur ? '▶ ' : '') + 'Day ' + day}
                </Text>

                {isMile ? (
                  <View style={[styles.milestone, { backgroundColor: done ? Colors.primary : Colors.accent }]}>
                    {done ? (
                      <Icon name="checkmark" size={20} color="#fff" />
                    ) : (
                      <Text style={styles.milestoneLabel}>{day + 'd'}</Text>
                    )}
                  </View>
                ) : (
                  <View style={[
                    styles.dot,
                    {
                      width: isCur ? 22 : (done ? 18 : 14),
                      height: isCur ? 22 : (done ? 18 : 14),
                      backgroundColor: done ? Colors.primary : (isCur ? Colors.primaryLight : 'rgba(255,255,255,0.7)'),
                      borderWidth: isCur ? 3 : 0,
                      borderColor: isCur ? Colors.primary : 'transparent',
                    },
                  ]} />
                )}
              </View>
            );
          })}
          <View style={{ height: 60 }} />
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.bgTop },
  safe: { flex: 1 },
  dateRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 20, paddingTop: 8 },
  dateText: { fontSize: 13, color: Colors.textMid },
  sunWrap: { alignItems: 'center', marginBottom: 8 },
  milestoneHeader: {
    marginHorizontal: 20,
    marginBottom: 12,
    padding: 14,
    borderRadius: 16,
    backgroundColor: Colors.primary,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  milestoneTitle: { color: '#fff', fontSize: 17, fontWeight: '700' },
  scroll: { flex: 1 },
  scrollContent: { paddingHorizontal: 20, paddingTop: 10, paddingBottom: 100 },
  dayRow: { flexDirection: 'row', alignItems: 'center', gap: 14, position: 'relative' },
  dayLabel: { position: 'absolute', width: 55, textAlign: 'right', fontSize: 12 },
  dayLabelCurrent: { fontSize: 15, fontWeight: '800', color: Colors.textDark },
  dayLabelDone: { fontWeight: '600', color: Colors.textMid },
  dayLabelFuture: { fontWeight: '400', color: Colors.textLight },
  dot: { borderRadius: 999 },
  milestone: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 6,
    elevation: 3,
  },
  milestoneLabel: { color: '#fff', fontSize: 13, fontWeight: '700' },
});
